import { Injectable } from '@angular/core';
import {CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router} from '@angular/router';
import { Observable } from 'rxjs';
import {AuthService} from "./auth.service";

@Injectable({
  providedIn: 'root'
})
export class AuthIsLoggedInGuard implements CanActivate {
  constructor(private authService: AuthService,
              private router: Router) {

  }
  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    if (this.authService.isLoggedIn()) {
      if (this.authService.check()) {
        this.router.navigate(['/main/dashboard']);
      }
      return !this.authService.isLoggedIn();
    } else {
      return !this.authService.isLoggedIn();
    }
  }
}
